/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'gh-list-item',
  template: require('./list-item.component.html'),
  styles: [require('./list-item.component.scss')],
})
export class ListItemComponent {
  @HostBinding('class.is-selected')
  @Input() selected: boolean;
}
